module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', [_vm._v("I'm a tenured Professor of Law at  "), _c('a', {
    attrs: {
      "href": "http://www.law.northwestern.edu/"
    }
  }, [_vm._v("Northwestern University Pritzker School of Law")]), _vm._v(". From 2012-2020 I was at the "), _c('a', {
    attrs: {
      "href": "https://law.uiowa.edu/paul-gowder"
    }
  }, [_vm._v("University of Iowa")]), _vm._v(" College of Law (with courtesy appointments in "), _c('a', {
    attrs: {
      "href": "https://clas.uiowa.edu/philosophy/people/paul-gowder"
    }
  }, [_vm._v("philosophy")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://clas.uiowa.edu/polisci/people/paul-gowder"
    }
  }, [_vm._v("political science")]), _vm._v(").  My research is focused on the nexus of normative political theory, constitutional law, and social science, as well as law and technology. (You can see more in the research section of this website.)")]), _vm._v(" "), _c('p', [_vm._v("As a law professor, I've taught beginning and advanced Constitutional Law courses, Torts, Introduction to Quantitative and Computational Legal Reasoning (a coding and statistics course for lawyers), Critical Race Theory, Policy Lab, and Professional Responsibility (legal ethics). Recently, I've also been teaching a seminar on Classical Athenian Law, which is secretly comparative constitutional law, but with a very novel comparator.")]), _vm._v(" "), _c('p', [_vm._v("My primary training was at "), _c('a', {
    attrs: {
      "href": "http://hls.harvard.edu/"
    }
  }, [_vm._v("Harvard Law School")]), _vm._v(" (J.D., 2000) and "), _c('a', {
    attrs: {
      "href": "https://politicalscience.stanford.edu/"
    }
  }, [_vm._v("Stanford Political Science")]), _vm._v(" (Ph.D., 2012).")]), _vm._v(" "), _c('p', [_vm._v("I've written three books, all of which you can buy in cloth or paper or download free open access PDFs:")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://rulelaw.net"
    }
  }, [_vm._v("The Rule of Law in the Real World")]), _vm._v(" (Cambridge University Press, 2016).")])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://rulelaw.us"
    }
  }, [_vm._v("The Rule of Law in the United States: An Unfinished Project of Black Liberation")]), _vm._v(" (Hart/Bloomsbury, 2021).")])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://networked-leviathan.com"
    }
  }, [_vm._v("The Networked Leviathan: For Democratic Platforms")]), _vm._v(" (Cambridge, 2023).")])])]), _vm._v(" "), _c('p', [_vm._v("I'm currently working on a fourth book about critical race constitutional theory.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e4abb0a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/bio-1.vue
// module id = 202
// module chunks = 0